import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { modalsActions, modalsConstants } from '../../modules/modals';

const useDetectDiffInChanges = (isUnsavedChanges, saveFn, setActiveSettingType) => {
  const dispatch = useDispatch();

  const onTabChangeHandler = useCallback(
    ({ detail }) => {
      if (isUnsavedChanges()) {
        dispatch(
          modalsActions.setModalStateFor(modalsConstants.MODAL_TYPES.SAVE_CHANGES_COMPANY_PROFILE, {
            open: true,
            entityId: null,
            nextSettingsName: detail,
          })
        );
      } else {
        setActiveSettingType(detail);
      }
    },
    [isUnsavedChanges]
  );

  const onSaveUnsavedDataHandler = useCallback(
    ({ detail }) => {
      if (saveFn) {
        saveFn();
      } else {
        document.forms[0].submit();
      }
      setTimeout(() => setActiveSettingType(detail), 0);
    },
    [saveFn]
  );

  useEffect(() => {
    document.addEventListener('onTabChange', onTabChangeHandler);
    document.addEventListener('onSaveUnsavedData', onSaveUnsavedDataHandler);

    return () => {
      document.removeEventListener('onTabChange', onTabChangeHandler);
      document.removeEventListener('onSaveUnsavedData', onSaveUnsavedDataHandler);
    };
  }, [onTabChangeHandler, onSaveUnsavedDataHandler]);
};

export default useDetectDiffInChanges;
